import { render, staticRenderFns } from "./ProductConfiguratorGroups.vue?vue&type=template&id=7af54f05&"
import script from "./ProductConfiguratorGroups.js?vue&type=script&lang=js&"
export * from "./ProductConfiguratorGroups.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../ProductConfigurator.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fproduct%2FProductConfigurator%2FProductConfiguratorGroups%2FProductConfiguratorGroups.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports